export enum TSAStatus {
  APPROVED = 'APPROVED',
  NOT_APPROVED = 'NOT_APPROVED',
  NOT_REQUIRED = 'NOT_REQUIRED',
}
